import { Box, Typography, useTheme } from "@mui/material";
import ChoiceCard from "./ChoiceCard";
import { ISurveyQuestion } from "../OwnerSurvey";

interface QuestionCardProps extends ISurveyQuestion {
  index: number;
  handleAnswer: (qId: string, selected: string, score: number) => void;
}
export default function QuestionCard(props: QuestionCardProps) {
  const {
    qstn,
    index,
    answ1,
    answ2,
    answ3,
    answ4,
    score1,
    score2,
    score3,
    score4,
    id,
    handleAnswer,
    selected,
  } = props;
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: "8px",
        padding: "8px",
        backgroundColor: theme.palette.bgColor.grey100,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          gap: "3px",
        }}
      >
        <Typography
          sx={{
            fontSize: "18px",
            color: "secondary.main",
          }}
        >
          {index + 1}.
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
          }}
        >
          {qstn}{" "}
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <ChoiceCard
          score={score1}
          selected={selected}
          handleAnswer={handleAnswer}
          qId={id}
          str={answ1}
        />
        <ChoiceCard
          score={score2}
          selected={selected}
          handleAnswer={handleAnswer}
          qId={id}
          str={answ2}
        />
        <ChoiceCard
          score={score3}
          selected={selected}
          handleAnswer={handleAnswer}
          qId={id}
          str={answ3}
        />
        <ChoiceCard
          score={score4}
          selected={selected}
          handleAnswer={handleAnswer}
          qId={id}
          str={answ4}
        />
      </Box>
    </Box>
  );
}
